import { gql } from '@common/hooks';

export type WeekDaysRates = {
  sunday: number;
  monday: number;
  tuesday: number;
  wednesday: number;
  thursday: number;
  friday: number;
  saturday: number;
};

export type VariableRatesType = {
  coreDayIncentiveRates: WeekDaysRates;
  coreNightIncentiveRates: WeekDaysRates;
  floatDayIncentiveRates: WeekDaysRates;
  floatNightIncentiveRates: WeekDaysRates;
};

export type StaticPricingTierInputType = {
  label: string;
  payRateCents: number;
  fillRateThreshold: number;
};

type Rates = {
  displayAsLumpSum?: boolean;
  priceRange: number;
  incentiveIncrement: number;
  variableRates: VariableRatesType;
  staticPricingTiers?: StaticPricingTierInputType[];
};

export type InsertWorkforceGroupUnitRatesMutationArgs = {
  effectiveDate: string;
  endDate: string | null;
  organizationUnitIds: string[];
  workforceGroupIds: string[];
  rates: Rates;
};

export type InsertWorkforceGroupUnitRatesMutationResponse = {
  insertWorkforceGroupUnitRates: {
    success: boolean;
  };
};

export const InsertWorkforceGroupUnitRatesMutation = gql`
  mutation BulkInsertWorkforceGroupUnitRates(
    $effectiveDate: ISO8601Date!
    $endDate: ISO8601Date
    $organizationUnitIds: [ID!]!
    $rates: RatesInput!
    $workforceGroupIds: [ID!]!
  ) {
    insertWorkforceGroupUnitRates(
      effectiveDate: $effectiveDate
      endDate: $endDate
      organizationUnitIds: $organizationUnitIds
      rates: $rates
      workforceGroupIds: $workforceGroupIds
    ) {
      success
    }
  }
`;
